import React from "react";
//internal and external components import
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { TableRow } from "@mui/material/";
import {
  sortData,
} from "../../common/SortSupport";
import { EnhancedTableHead } from "../EnhancedTableHead";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Box } from "@mui/material";
import { colors } from "../../common/pallette/colors";
import TableSkeleton from "../TableSkeleton";
import { genUID } from "../../common/StaticExports";
import StatusIndicatorSmall from "../StatusIndicatorSmall";

const ReportsStandardsTable = (props:any) => {

    const { data } = props;

  //supporting contents
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("Uid");

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  let visibleRows = React.useMemo(
    () =>
      data && data.length > 0 && sortData(data, orderBy, order),
    [order, orderBy, data]
  );

  const head = [
    {
      key: "Uid",
      displayName: "id",
    },
    {
      key: "Name",
      displayName: "standards",
    },
    {
      key: "Status",
      displayName: "off-site",
    },
  ];
    // {
    //   key: "StarRating",
    //   displayName: "star",
    // },

  //table contents
  return (
    <React.Fragment>
      <Box className={'mb20'}>
        <TableContainer>
          <Table stickyHeader size="small" aria-label="a dense table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              tableHeads={head}
            />
            {visibleRows.length ? (
              <TableBody>
                {visibleRows.map((d: any, i: number) => (
                  <TableRow
                    className="hoverBG"
                    sx={{ cursor: "pointer" }}
                    key={`standards-table-row-${i}`}
                  >
                    <TableCell className="fs12">{genUID(d.Uid)}</TableCell>
                    <TableCell
                      className="fs12"
                    >
                      {d.Name}
                    </TableCell>
                    <TableCell className="fs12">
                        <StatusIndicatorSmall reportType={'siteReview'} status={d?.Status}/>
                    </TableCell>
                    {/* <TableCell className="fs12">
                      {Array.from({ length: d.StarRating }, () => (
                        <FontAwesomeIcon
                          icon={faStar}
                          style={{ color: colors.yellow.bright }}
                        />
                      ))}
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableSkeleton rowCount={8} cellCount={5} />
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Box>
    </React.Fragment>
  );
};

export default ReportsStandardsTable;
